export default "__VITE_ASSET__4UgVdOzp__"